export default __webpack_public_path__ + "static/SR France - Organic - Certificate-994ca2bd5a1cd91f6bfe0a9bc0ecb83a.pdf";